import { render, staticRenderFns } from "./hisSubordinate.vue?vue&type=template&id=635a94b4&"
import script from "./hisSubordinate.vue?vue&type=script&lang=js&"
export * from "./hisSubordinate.vue?vue&type=script&lang=js&"
import style0 from "./hisSubordinate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports